"use client";
import {
  useCollectionStoreProps
} from "./TCAGH6BH.js";
import {
  useStore,
  useStoreProps
} from "./2GXGCHW6.js";

// src/composite/composite-store.ts
import * as Core from "@ariakit/core/composite/composite-store";
function useCompositeStoreProps(store, update, props) {
  store = useCollectionStoreProps(store, update, props);
  useStoreProps(store, props, "activeId", "setActiveId");
  useStoreProps(store, props, "includesBaseElement");
  useStoreProps(store, props, "virtualFocus");
  useStoreProps(store, props, "orientation");
  useStoreProps(store, props, "rtl");
  useStoreProps(store, props, "focusLoop");
  useStoreProps(store, props, "focusWrap");
  useStoreProps(store, props, "focusShift");
  return store;
}
function useCompositeStore(props = {}) {
  const [store, update] = useStore(Core.createCompositeStore, props);
  return useCompositeStoreProps(store, update, props);
}

export {
  useCompositeStoreProps,
  useCompositeStore
};
